import type { DemandScaling, RotaTemplateScope, SchedulingRuleset, ShiftSet } from './template';

export const TEMPLATE_STATUSES = ['published', 'draft', 'deleted'] as const;
export type TemplateStatus = (typeof TEMPLATE_STATUSES)[number];

/** Statuses listed when no status filter is chosen; matches the backend default. */
export const DEFAULT_TEMPLATE_STATUSES: readonly TemplateStatus[] = ['published', 'draft'];

export interface SavedTemplate {
  id: string;
  name: string;
  type: 'standard';
  /** Contract scope: `{ sites?: Identifiable[] }`. Empty/undefined ⇒ all sites. */
  scope: RotaTemplateScope;
  /** Contract `RotaTemplate.description` is required; defaults to ''. */
  description: string;
  shifts: ShiftSet[];
  /** Canonical, contract-shaped scheduling rules. */
  schedulingRules: SchedulingRuleset;
  /** Template-level demand scaling settings (drives per-shift scaling + baseline). */
  demandScaling?: DemandScaling;
  status: TemplateStatus;
  createdAt: string; // ISO date string
  createdBy: string;
  modifiedAt: string; // ISO date string
  modifiedBy: string;
  lastUsedAt?: string; // ISO date string - when template was last applied to a rota
  timesUsed?: number; // Number of times template has been applied
  activatedAt?: string; // ISO date string - when template was activated
}

export interface TemplateFilters {
  search: string;
  sites: string[]; // Empty array means show all
  statuses: TemplateStatus[];
  sortBy: 'recentlyModified' | 'recentlyCreated' | 'alphabetical' | 'totalShifts' | 'lastUsed';
}

export interface TemplateStats {
  totalShifts: number;
  totalHoursPerWeek: number;
}
